<template>
  <div
    class="fit flex flex-center duration-700 absolute left-0 top-0"
    :style="{
      transform: `scale(${views[value.toLowerCase()].scale}) translate(${views[value.toLowerCase()].x}%, ${views[value.toLowerCase()].y}%)`,
    }"
  >
    <div class="flex h-full bg- relative" style="width: fit-content">
      <img
        src="/maintenance/forklift.png"
        class="h-full object-contain"
        draggable="false"
      />
      <div class="fit absolute left-0 top-0 bg- pointer-events-none">
        <img
          @click="$emit('input', key)"
          v-for="(tire, key) in tyres"
          v-if="visible.includes(key.toUpperCase())"
          src="/maintenance/tyre.png"
          alt=""
          class="absolute object-contain cursor-pointer hover-scale duration-200"
          style="height: 18%; pointer-events: auto"
          :style="{ left: `${tire.x}%`, top: `${tire.y}%` }"
          draggable="false"
        />
        <!-- <span v-for="(tire, key) in tyres">
          {{ key }}
        </span>
        {{ visible }} -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
  value: { default: 'general' },
  ui: { default: false },
});

// const view = ref('br');

const visible = computed(() => {
  let arr = [];
  if (props.ui) {
    for (const key in props.ui) {
      let obj = props.ui[key];
      arr.push(...obj);
    }
  }
  return arr;
});

const views = {
  general: { scale: 0.9, x: 0, y: 0 },
  fr1: { scale: 2, x: -20, y: 0 },
  fl1: { scale: 2, x: 20, y: 0 },
  br1: { scale: 2, x: -20, y: -22 },
  bl1: { scale: 2, x: 20, y: -22 },
};
const tyres = {
  fl1: {
    x: -2,
    y: 36,
  },
  fr1: {
    x: 71,
    y: 36,
  },
  bl1: {
    x: -2,
    y: 65,
  },
  br1: {
    x: 71,
    y: 65,
  },
};
</script>

<style lang="scss" scoped>
.hover-scale:hover {
  transform: scale(1.1);
}
</style>
